export default __webpack_public_path__ + "static/media/fintech-icon-04.a6b0bd85.svg";